import React, { useEffect, useState, useCallback } from 'react';

import { Link } from 'react-router-dom';

import { Divider } from '@material-ui/core';
import { FiEdit3 } from 'react-icons/fi';

import api from '../../services/api';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

import * as S from './styles';

export interface GrupoReforma {
  id: number;
  descricao: string;
  cst_ibs_cbs?: string | null;
  c_class_trib?: string | null;
  aliquota_cbs?: string | number | null;
}

const RegrasIbsCbsIs: React.FC = () => {
  const [grupos, setGrupos] = useState<GrupoReforma[]>([]);

  const { user } = useAuth();
  const { addToast } = useToast();

  useEffect(() => {
    async function loadGrupos(): Promise<void> {
      try {
        const response = await api.get(
          `companies/${user.empresa_id}/grupos-tributarios`,
        );
        setGrupos(response.data);
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao carregar grupos tributários',
        });
      }
    }

    loadGrupos();
  }, [user.empresa_id, addToast]);

  const renderRow = useCallback(
    (grupo: GrupoReforma) => (
      <S.TableRow key={grupo.id}>
        <S.TableCellRow>
          <p>{grupo.descricao}</p>
        </S.TableCellRow>
        <S.TableCellRow>
          <p>{grupo.cst_ibs_cbs || '-'}</p>
        </S.TableCellRow>
        <S.TableCellRow>
          <p>{grupo.c_class_trib || '-'}</p>
        </S.TableCellRow>
        <S.TableCellRow>
          <p>{grupo.aliquota_cbs ?? '-'}</p>
        </S.TableCellRow>
        <S.TableCellRow>
          <Link to={`/regras-ibs-cbs-is/edit/${grupo.id}`}>
            <FiEdit3 size={20} />
          </Link>
        </S.TableCellRow>
      </S.TableRow>
    ),
    [],
  );

  return (
    <S.Container>
      <div className="header">
        <h2>Regras IBS, CBS e IS</h2>
        <p>
          Edite os campos da reforma tributária (IBS / CBS / IS) dos mesmos
          grupos de regras tributárias. As alíquotas de ICMS/PIS/COFINS são
          gerenciadas na tela &quot;Grupos de Regras Tributárias&quot;.
        </p>
      </div>

      <Divider />

      <S.ContainerList>
        <S.CustomTable>
          <S.TableHeader>
            <span>Descrição</span>
            <span>CST IBS/CBS</span>
            <span>cClassTrib</span>
            <span>Alíq. CBS</span>
            <span>Editar</span>
          </S.TableHeader>
          <S.TableBody>{grupos.map(renderRow)}</S.TableBody>
        </S.CustomTable>
      </S.ContainerList>
    </S.Container>
  );
};

export default RegrasIbsCbsIs;
